import {
  SCHEDULE_FETCH_REQUEST,
  SCHEDULE_FETCH_SUCCESS,
  SCHEDULE_FETCH_FAILURE,
  SCHEDULE_GENERATE_REQUEST,
  SCHEDULE_GENERATE_SUCCESS,
  SCHEDULE_GENERATE_FAILURE,
  SCHEDULE_PDF_REQUEST,
  SCHEDULE_PDF_SUCCESS,
  SCHEDULE_PDF_FAILURE,
  SCHEDULE_TATAMI_PDF_REQUEST,
  SCHEDULE_TATAMI_PDF_SUCCESS,
  SCHEDULE_TATAMI_PDF_FAILURE,
} from 'actions';

const initialState = {
  data: null,
  isFetching: false,
  isFetched: false,
  isGenerating: false,
  isDownloadingPdf: false,
  // Set of tatamiId values currently downloading a tatami PDF.
  downloadingTatamis: [],
};

export const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_FETCH_REQUEST:
      return { ...initialState, isFetching: true };

    case SCHEDULE_FETCH_SUCCESS:
      return { ...state, isFetching: false, isFetched: true, data: action.data };

    case SCHEDULE_FETCH_FAILURE:
      return { ...initialState, isFetched: true };

    case SCHEDULE_GENERATE_REQUEST:
      return { ...state, isGenerating: true };

    case SCHEDULE_GENERATE_SUCCESS:
      return { ...state, isGenerating: false, isFetched: true, data: action.data };

    case SCHEDULE_GENERATE_FAILURE:
      return { ...state, isGenerating: false };

    case SCHEDULE_PDF_REQUEST:
      return { ...state, isDownloadingPdf: true };

    case SCHEDULE_PDF_SUCCESS:
    case SCHEDULE_PDF_FAILURE:
      return { ...state, isDownloadingPdf: false };

    case SCHEDULE_TATAMI_PDF_REQUEST:
      return {
        ...state,
        downloadingTatamis: [...state.downloadingTatamis, action.tatamiId],
      };

    case SCHEDULE_TATAMI_PDF_SUCCESS:
    case SCHEDULE_TATAMI_PDF_FAILURE:
      return {
        ...state,
        downloadingTatamis: state.downloadingTatamis.filter(id => id !== action.tatamiId),
      };

    default:
      return state;
  }
};
